import axiosInstance from '@/shared/api/http';
import { API } from '@/shared/constants/api';
import ServiceBuilder from '@/shared/lib/utils/service';
const register = async (fields) => ServiceBuilder.serviceRequest(async () => {
    const response = await axiosInstance.post(API.signUp, fields, {
        timeout: 30000,
    });
    return response;
});
export default register;
export function getQueryParam(param) {
    const queryString = window.location.search.substring(1);
    const params = queryString.split('&');
    for (let i = 0; i < params.length; i += 1) {
        const pair = params[i].split('=');
        if (pair[0] === param) {
            return decodeURIComponent(pair[1]);
        }
    }
    return null;
}
